import React from 'react';
import {useProductAttributes} from '../../../state';
import {ContactsSkeleton} from "../Skeleton/ContactsSkeleton";
import {FormattedMessage} from 'react-intl';
import {UserIcon} from '../../../../../general/assets/UserIcon';

export const Contacts = () => {
    const {productAttributes, customAttributes, loading, agentsConfiguration, agentsLoading} = useProductAttributes() || {};

    const contacts = agentsConfiguration?.map(agent => ({
        name: agent.agent_name,
        locations: agent.regions.join(', ').toUpperCase(),
        colorCode: agent.color_code,
        agentImageUrl: agent.agent_image
    })) || [];

    if (loading || agentsLoading) {
        return <ContactsSkeleton/>;
    }

    if (!productAttributes || !customAttributes) {
        return null;
    }

    const f_tip_produs_attribute = customAttributes.find(
        attribute => attribute.attribute_code === 'f_tip_produs'
    );

    const f_tip_produs_value = f_tip_produs_attribute ? f_tip_produs_attribute.value : null;

    if (f_tip_produs_value === 'Utilaje') {
        return (
            <div>
                <div
                    className={'flex flex-col space-y-2.5 rounded-xl bg-cards-bg xl:my-6 px-8 py-5 mt-2 xl:mt-4'}>
                    <p className={'text-center text-slate-700 font-bold text-lg leading-normal mb-4 font-montserrat'}>
                        <FormattedMessage id={'contacts_title'}/>
                    </p>
                    <div className="content">
                        <div className="flex flex-row items-center content-center">
                            <div className="mr-5 w-1/5 flex justify-center">
                                <a href="tel:0371.710.074" className={'hover:text-current'}>
                                    <i className="fas fa-phone w-16 h-16 font-black text-white text-4xl leading-none bg-custom-green rounded-full p-4 border-0 box-border"></i>
                                </a>
                            </div>
                            <div className="flex flex-col justify-evenly flex-initial w-4/5">
                                <a className={'font-montserrat text-custom-gray font-bold text-base leading-4.5 hover:text-current'}
                                   href="tel:0371.710.074">0371.710.074</a>
                                <a href="tel:0371.710.074"
                                   className={'text-custom-gray font-normal text-sm leading-4.5 font-nunito hover:text-current'}>
                                    <FormattedMessage id={'contacts_callback_info'}/>
                                </a>
                            </div>
                        </div>
                    </div>
                    {contacts.map(contact =>
                        <div className="content" key={contact.name}>
                            <div className="flex flex-row items-center content-center">
                                <div className="mr-5 w-1/5 flex justify-center">
                                    <div 
                                        className="w-16 h-16 rounded-full p-1 flex items-center justify-center"
                                        style={{ 
                                            backgroundColor: contact.colorCode || '#10b981'
                                        }}
                                    >
                                        {contact.agentImageUrl ? (
                                            <div 
                                                className="w-full h-full rounded-full bg-cover bg-center"
                                                style={{ 
                                                    backgroundImage: `url(${contact.agentImageUrl})`
                                                }}
                                            />
                                        ) : (
                                            <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
                                                <UserIcon size="w-8 h-8" color="#9ca3af" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col justify-evenly flex-initial w-4/5">
                                    <p className="font-montserrat text-custom-gray font-bold text-sm leading-7">{contact.name}</p>
                                    <p className="text-custom-gray font-normal text-xs leading-4.5 font-nunito">{contact.locations}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    } else if (f_tip_produs_value === 'Piese') {
        return (
            <div
                className="flex flex-col space-y-2.5 rounded-xl bg-cards-bg xl:my-6 px-8 py-5 mt-2 xl:mt-4">
                <p className="text-center text-slate-700 font-bold text-lg leading-normal mb-4 font-montserrat">
                    <FormattedMessage id={'contacts_title'}/>
                </p>
                <div className="content">
                    <div className="flex flex-row items-center content-center">
                        <div className="mr-5 w-1/5 flex justify-center">
                            <a href="tel:0371.710.072">
                                <i className="fas fa-phone w-16 h-16 font-black text-white text-4xl leading-none bg-custom-green rounded-full p-4 border-0 box-border"></i>
                            </a>
                        </div>
                        <div className="flex flex-col justify-evenly flex-initial w-4/5">
                            <a className={'font-montserrat text-custom-gray font-bold text-base leading-4.5 hover:text-current'}
                               href="tel:0371.710.072">0371.710.072
                            </a>
                            <a className={'text-custom-gray font-normal text-sm leading-4.5 font-nunito hover:text-current'}
                               href="tel:0371.710.072">
                                <FormattedMessage id={'contacts_parts_info'}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div
                className="flex flex-col space-y-2.5 rounded-xl bg-cards-bg xl:my-6 px-8 py-5 mt-2 xl:mt-4">
                <p className="text-center text-slate-700 font-bold text-lg leading-normal mb-4 font-montserrat">
                    <FormattedMessage id={'contacts_title'}/>
                </p>
                <div className="content">
                    <div className="flex flex-row items-center content-center">
                        <div className="mr-5 w-1/5 flex justify-center">
                            <a href="tel:0371.710.071">
                                <i className="fas fa-phone w-16 h-16 font-black text-white text-4xl leading-none bg-custom-green rounded-full p-4 border-0 box-border"></i>
                            </a>
                        </div>
                        <div className="flex flex-col justify-evenly flex-initial w-4/5">
                            <a className={'font-montserrat text-custom-gray font-bold text-base leading-4.5 hover:text-current'}
                               href="tel:0371.710.071">0371.710.071
                            </a>
                            <a className={'text-custom-gray font-normal text-sm leading-4.5 font-nunito hover:text-current'}
                               href="tel:0371.710.071">
                                <FormattedMessage id={'contacts_general_sales'}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
